import type { ApiError } from "../api";

/** Type Guard for `ApiError` */
export function isApiError<T>(error: unknown): error is ApiError<T> {
  return !!error && (error as ApiError<T>).isAxiosError === true;
}
